import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITeacher, ITeachers } from '../interfaces/teacher';
import { ISchools } from '../interfaces/school';

@Injectable({
  providedIn: 'root',
})
export class TeacherService {
  constructor(private httpClient: HttpClient) {}

  getTeachers(url: string, filters: any): Observable<ITeachers> {
    return this.httpClient.get<ITeachers>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<ITeachers>;
  }

  getTeacherById(url: string): Observable<ITeacher> {
    return this.httpClient.get<ITeacher>(url, { headers: { accept: '*/*' } }) as Observable<ITeacher>;
  }

  editTeacher(url: string, teacherForm: any): Observable<ITeacher> {
    return this.httpClient.patch<ITeacher>(url, teacherForm, {
      headers: { accept: '*/*' },
    }) as Observable<ITeacher>;
  }

  createTeacher(url: string, teacherForm: any): Observable<ITeacher> {
    return this.httpClient.post<ITeacher>(url, teacherForm, {
      headers: { accept: '*/*' },
    }) as Observable<ITeacher>;
  }
}
